var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-collapse",
    {
      on: { change: _vm.handleChange },
      model: {
        value: _vm.activeNames,
        callback: function ($$v) {
          _vm.activeNames = $$v
        },
        expression: "activeNames",
      },
    },
    [
      _c("el-collapse-item", { attrs: { title: "Battery", name: "1" } }, [
        _vm.chartOptions.rssi.hasOwnProperty("chart")
          ? _c(
              "div",
              [
                _c("highcharts", {
                  attrs: { options: _vm.chartOptions.battery },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "el-collapse-item",
        { attrs: { title: "RSSI", name: "2" } },
        [_c("highcharts", { attrs: { options: _vm.chartOptions.rssi } })],
        1
      ),
      _vm._v(" "),
      _c(
        "el-collapse-item",
        { attrs: { title: "Stream Profile", name: "3" } },
        [_c("highcharts", { attrs: { options: _vm.chartOptions.stream } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }